import FriendlyCaptcha from './FriendlyCaptcha'

export default FriendlyCaptcha